import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShareButton from '../ShareButton';
import TournamentShareModal from '../tournament/TournamentShareModal';

interface TournamentHeaderProps {
  torneio: {
    id: string;
    nome: string;
    avatarUrl?: string | null;
  };
  onEdit?: () => void;
}

const TournamentHeader: React.FC<TournamentHeaderProps> = ({ torneio, onEdit }) => {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigateToTorneio = () => {
    navigate(`/tournamentsingle/${torneio.id}`);
  };

  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3">
      <div className="card-body p-4">
        <div className="d-flex align-items-center mb-3">
          <img
            src={torneio.avatarUrl || '/assets/images/tournament.png'}
            alt={torneio.nome}
            className="rounded-circle me-3"
            style={{ width: '64px', height: '64px', objectFit: 'cover', cursor: 'pointer' }}
            onClick={handleNavigateToTorneio}
          />
          <div className="flex-grow-1">
            <h3
              className="fw-700 mb-0"
              style={{ cursor: 'pointer' }}
              onClick={handleNavigateToTorneio}
            >
              {torneio.nome}
            </h3>
          </div>
          <div className="d-flex gap-2">
            <ShareButton
              onClick={() => setShareModalOpen(true)}
              variant="outlined"
              size="medium"
            />
            {onEdit && (
              <button className="btn btn-primary" onClick={onEdit}>
                Editar
              </button>
            )}
          </div>
        </div>
      </div>

      <TournamentShareModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        torneioId={torneio.id}
        torneioNome={torneio.nome}
      />
    </div>
  );
};

export default TournamentHeader;

